import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSkipForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1308 2.81215L11.9689 1.47696L13.1752 1.33301L13.5527 4.44743C13.5722 4.60814 13.5257 4.76987 13.4238 4.89621C13.3218 5.02255 13.1729 5.10289 13.0106 5.11915L10.0006 5.42053L9.87863 4.22104L11.7103 4.03764C10.7365 3.151 9.43924 2.61057 8.01578 2.61057C4.99792 2.61057 2.54832 5.04119 2.54832 8.03567C2.54832 11.0301 4.99792 13.4608 8.01578 13.4608C10.1583 13.4608 12.0158 12.2357 12.9126 10.4504L14 10.9882C12.9058 13.1665 10.6371 14.6663 8.01578 14.6663C4.3269 14.6663 1.33333 11.696 1.33333 8.03567C1.33333 4.37537 4.3269 1.405 8.01578 1.405C9.56779 1.405 10.9965 1.93106 12.1308 2.81215Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconSkipForward;
